import DefectsCategories from './DefectsCategories/DefectsCategories.vue';
import DefectsCategoriesCreateEdit from './DefectsCategories/DefectsCategoriesCreateEdit.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Quality from './Master/Quality.vue';
import QualityCreateEdit from './Master/QualityCreateEdit.vue';
import ReportQuality from './Report/Reports.vue';
import SamplingReport from './SamplingReport/SamplingReport.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const QualityRoutes = {
  path: 'quality',
  name: 'Calidad',
  component: MasterTab,
  props: { reference: 'qualityTabs' },
  children: [
    {
      path: 'inspections',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Calidad',
          component: ReportQuality,
          meta: {
            prefix_permission: 'quality_inspections',
          },
        },
      ],
    },
    {
      path: 'samplingreport',
      name: 'Calidad',
      component: SamplingReport,
      meta: {
        prefix_permission: 'quality_samplingreport',
      },
    },
    {
      path: 'quality',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Calidad',
          component: Quality,
          meta: {
            prefix_permission: 'quality_quality',
          },
        },
        {
          path: 'create',
          name: 'Calidad',
          component: QualityCreateEdit,
          meta: {
            prefix_permission: 'quality_quality',
          },
        },
        {
          path: 'edit',
          name: 'Calidad',
          component: QualityCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'quality_quality',
          },
        },
      ],
    },
    {
      path: 'captures',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Calidad',
          component: () =>
            import('src/views/Pages/Dashboard/Quality/Quality/Capture.vue'),
          meta: {
            prefix_permission: 'quality_inspections',
          },
        },
      ],
    },
    {
      path: 'defectscategories',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Calidad',
          component: DefectsCategories,
          meta: {
            prefix_permission: 'quality_Defectscategories',
          },
        },
        {
          path: 'create',
          name: 'Calidad',
          component: DefectsCategoriesCreateEdit,
          meta: {
            prefix_permission: 'quality_DefectsCategoriesCreateEdit',
          },
        },
        {
          path: 'edit',
          name: 'Calidad',
          component: DefectsCategoriesCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'quality_DefectsCategoriesCreateEdit',
          },
        },
      ],
    },
  ],
};

export default QualityRoutes;
